Vue.component("shop-map-view", {
	template: `
	<div class="google-map" id="search-shop-map">
		<p class="loading" v-if="!shop">読み込み中...</p>
	</div>
	`,
	props: ["shop"],
	data() {
		return {
			rendered: false,
			marker: null
		};
	},
	watch: {
		shop() {
			var me = this;
			if (me.shop && !me.rendered) {
				me.initMap();
			}
		}
	},
	mounted() {
		var me = this;
		if (me.shop && !me.rendered) {
			me.initMap();
		}
	},
	methods: {
		initMap() {
			var me = this, position, mapE, map, marker;

			position = new google.maps.LatLng(me.shop.lat, me.shop.lng);

			mapE = document.getElementById("search-shop-map");
			map = new google.maps.Map(mapE, {
				zoom: 14,
				minZoom: 10,
				center: position,
				fullscreenControl: false,
				clickableIcons: false,
			});

			marker = new google.maps.Marker({
				map: map,
				position: position
			});

			me.rendered = true;
		}
	},
});
